import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { api } from "../lib/api";

const addMonths = (ym, k) => { const [y, m] = ym.split("-").map(Number); const d = new Date(y, m - 1 + k, 1); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`; };

export const ViolationInstallmentDialog = ({ v, onOpenChange, onSaved }) => {
  const [months, setMonths] = useState(3);
  const [start, setStart] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!v) return;
    setMonths(v.installment_months || 3);
    setStart(v.installment_start || new Date().toISOString().slice(0, 7));
  }, [v]);
  const n = Math.max(1, Number(months) || 1);
  const per = v ? Math.round((Number(v.amount || 0) / n) * 100) / 100 : 0;
  const save = async (m) => {
    setBusy(true);
    try {
      await api.setViolationInstallment(v.id, m, start);
      toast.success(m ? "تم تقسيط المخالفة — تُخصم من الرواتب تلقائياً" : "تم إلغاء التقسيط");
      onSaved(); onOpenChange(false);
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الحفظ"); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!v} onOpenChange={onOpenChange}>
      <DialogContent dir="rtl" className="sm:max-w-sm" data-testid="viol-inst-dialog">
        <DialogHeader className="text-start"><DialogTitle>تقسيط المخالفة</DialogTitle>
          <DialogDescription>{v?.employee_name} · المبلغ {Number(v?.amount || 0).toLocaleString("en-US")} ر.س</DialogDescription></DialogHeader>
        <div className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5"><Label>عدد الأشهر</Label><Input type="number" min={1} max={24} value={months} onChange={(e) => setMonths(e.target.value)} data-testid="viol-inst-months" /></div>
            <div className="space-y-1.5"><Label>بداية الخصم</Label><Input type="month" value={start} onChange={(e) => setStart(e.target.value)} data-testid="viol-inst-start" /></div>
          </div>
          <div className="rounded-xl bg-amber-50 px-3 py-2 text-sm text-amber-900" data-testid="viol-inst-preview">
            قسط شهري <b className="font-mono-nums">{per.toLocaleString("en-US")}</b> ر.س لمدة {n} شهر — من {start} إلى {start ? addMonths(start, n - 1) : "—"}
            <p className="mt-0.5 text-[11px] text-amber-700">يُخصم تلقائياً في الرواتب عند تفعيل «المخالفات المرورية» في الخصومات التلقائية.</p>
          </div>
          <div className="flex gap-2">
            <Button className="flex-1" disabled={busy || !start} onClick={() => save(n)} data-testid="viol-inst-save">{busy && <Loader2 className="h-4 w-4 animate-spin" />} حفظ التقسيط</Button>
            {v?.installment_months > 0 && <Button variant="outline" className="text-rose-600" disabled={busy} onClick={() => save(0)} data-testid="viol-inst-cancel">إلغاء التقسيط</Button>}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
